export default "__VITE_ASSET__B67vn4Ew__"